import { dimens } from '@/shahrzad-assets/shared-constants/dimens'
import PageTitle from '@/shahrzad-assets/shared_components/PageTitle'
import styled from 'styled-components'
import { icons } from '@/shahrzad-assets/shared-asstes/icons'
import { fontSize, fontsWeight } from '@/shahrzad-assets/shared-constants/fonts'
import { colors } from '@/shahrzad-assets/shared-constants/colors'
import CustomButton from '@/shahrzad-assets/shared_components/CustomButton'
import { useContext, useEffect } from 'react'
import { FullScreenModalContext } from '@/shahrzad-assets/shared_components/FullScreenModalContext'
import SendInvitationModal from '@/components/home/SendInvitationModal'
import EditUserModal from '@/components/home/EditUserModal'
import UseGetMembers from '@/hooks/FamilyProfile/useGetMembers'
import { useLocation } from 'react-router-dom'
import CustomLoading from '@/shahrzad-assets/shared_components/CustomLoading'
import { UserInfoContext } from '@/shahrzad-assets/shared-contexts/UserInfoContext'
import ProfileFamilyFeatures from '@/components/home/ProfileFamilyFeatures'
import ContentLayout from '@/shahrzad-assets/shared_components/ContentLayout'

const Group = () => {
  const {userInfo} = useContext(UserInfoContext)

  const { show, setComponent, setTitle } = useContext(FullScreenModalContext)
  const { fetchGroupsMembers, groupsMembersLoading, members } = UseGetMembers()
  const { state } = useLocation();

  useEffect(() => {
    fetchGroupsMembers({groupId: state.groupId});
  },[])

  const openInvitationModal = () => {
    setComponent(<SendInvitationModal 
      parentBirthDate={userInfo?.PersianBirthDate} 
      parentNationalCode={userInfo?.NationalCode} 
      groupId={state.groupId} 
      groupTypeId={state.groupTypeId}
      parentId={members[0]?.memberRoleId}
      groupName={state.title}
    />)
    setTitle('ارسال دعوت نامه')
    show()
  }

  /*const openEditUserModal = (name: string, lastName: string) => {
    setComponent(<EditUserModal name={name} lastName={lastName} groupName={state.title}/>)
    setTitle('ویرایش کاربر')
    show()
  }*/
  return (
    <>
      <PageTitle title={`گروه ${state?.title}`} />
      <ContentLayout>
        <Content>
          <FamilyMembers>
            <h4 className='title'>اعضای گروه</h4>
            <MembersList>
              {
                groupsMembersLoading ? <CustomLoading/> : (
                  members?.map((data, i) => (
                    <Member key={i}>
                      <MemberInfo>
                        <img src={icons.EMPLOYEE} alt='member-image' />
                        <div className='info'>
                          <span className='name'>{data?.name} {data?.lastName}</span>
                          <span className='nationalCode'>{data?.nationalCode}</span>
                        </div>
                      </MemberInfo>
                      {/*<MemberStatus>
                        <div className='status'>
                          <img src={icons.CIRCLE_SUCCESS} alt='info' />
                          <span>فرزند</span>
                        </div>
                        <img
                          src={icons.PRIMARY_EDIT}
                          onClick={() => openEditUserModal(data?.name,data?.lastName)}
                          className='edit-icon'
                          alt='edit-icon'
                        />
                      </MemberStatus>*/}
                    </Member>
                  ))
                )
              }
            </MembersList>
          </FamilyMembers>
          <GroupDescription>
            <h4>توضیحات گروه</h4>
            <p className='description'>
              این گروه قابلیت ویژه‌ای را برای مدیریت افراد خانواده در اختیار شما
              قرار می‌دهد. لازم به ذکر است برای تشکیل این گروه لازم است شما
              سرپرست خانواده باشید!
            </p>
          </GroupDescription>
          <Features>
            <h4>امکانات</h4>
            <ProfileFamilyFeatures/>
          </Features>
        </Content>
        <BtnContainer>
          <CustomButton onClick={openInvitationModal}>
            <img src={icons.PLUS_WHITE}/>
            عضو جدید
          </CustomButton>
        </BtnContainer>
      </ContentLayout>
    </>
  )
}

export default Group

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${dimens.SPACING_XXL};
`

const FamilyMembers = styled.div`
  h4 {
    padding: 0 ${dimens.SPACING_XXL};
    padding-bottom: ${dimens.SPACING_XL};
  }
`

const MembersList = styled.ul`
  padding: 0 ${dimens.SPACING_XXXXXXXL};
  display: flex;
  flex-direction: column;
  gap: ${dimens.SPACING_XL};
`

const Member = styled.li`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

const MemberInfo = styled.div`
  display: flex;
  align-items: center;
  gap: ${dimens.SPACING_M};

  img {
    width: 3.75rem;
    aspect-ratio: 1;
  }

  .info {
    display: flex;
    flex-direction: column;
    gap: ${dimens.SPACING_XS};

    .name {
      font-weight: ${fontsWeight.BOLD};
    }

    .nationalCode {
      color: ${colors.text3};
    }
  }
`

const MemberStatus = styled.div`
  display: flex;
  align-items: center;
  gap: ${dimens.SPACING_S};

  .status {
    display: flex;
    align-items: center;
    gap: ${dimens.SPACING_XXS_NUDGE};
    
    background-color: ${colors.approveBg3};
    
    color: ${colors.approveTextPress};
    padding: ${dimens.SPACING_XXS_NUDGE} ${dimens.SPACING_XS};
    border-radius: ${dimens.BORDER_RADIUS_4};
    font-weight: ${fontsWeight.BOLD};
    font-size: ${fontSize.SMALL};

    &.warning {
      background-color: ${colors.warningBg2};
      color: ${colors.warningBg};
    }

    img {
      width: 1rem;
      aspect-ratio: 1;
    }
  }

  .edit-icon {
    cursor: pointer;
  }
`

const GroupDescription = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${dimens.SPACING_S};
  padding: 0 ${dimens.SPACING_XXL};
`

const Features = styled.div`
  padding: 0 ${dimens.SPACING_XXL};
  margin-bottom: ${dimens.SPACING_M};
  display: flex;
  flex-direction: column;
  gap: ${dimens.SPACING_S};
`

const BtnContainer = styled.div`
  margin: 0 ${dimens.SPACING_XXL};
  display: flex;
  justify-content: flex-end;

  img {
    width: 1rem;
    margin-left: ${dimens.SPACING_XXS_NUDGE};
  }
`
